
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import seoGlobals from '../seo_globals.json';

const Breadcrumbs: React.FC = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Don't show on home page
    if (pathnames.length === 0) return null;

    const baseUrl = seoGlobals.technical.baseUrl || 'https://vanity.co.at';

    // BreadcrumbList Schema Construction
    const schemaItems = [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": baseUrl
        }
    ];

    pathnames.forEach((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const pageName = name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' '); // Determine prettier name?

        schemaItems.push({
            "@type": "ListItem",
            "position": index + 2,
            "name": pageName,
            "item": `${baseUrl}${routeTo}`
        });
    });

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": schemaItems
    };

    return (
        <nav aria-label="Breadcrumb" className="w-full max-w-screen-xl mx-auto px-6 md:px-12 py-4">
            {/* Visual Breadcrumbs */}
            <ol className="flex items-center space-x-2 text-[10px] uppercase tracking-widest font-sans text-vanity-charcoal/60">
                <li>
                    <Link to="/" className="hover:text-vanity-pink transition-colors">Home</Link>
                </li>
                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;
                    const pageName = name.replace(/-/g, ' ');

                    return (
                        <li key={name} className="flex items-center space-x-2">
                            <span>/</span>
                            {isLast ? (
                                <span className="text-vanity-black font-bold" aria-current="page">
                                    {pageName}
                                </span>
                            ) : (
                                <Link to={routeTo} className="hover:text-vanity-pink transition-colors">
                                    {pageName}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(breadcrumbSchema)}
            </script>
        </nav>
    );
};

export default Breadcrumbs;
